import { Component, Input } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { UserProfile } from 'se-resource-types/dist/lib/CentralService/Households'

const exampleHtml = `
<div>
  <se-po-persona-avatar-group [profiles]="profiles">
  </se-po-persona-avatar-group>
</div>
`

const exampleTypescript = `
import { Component } from '@angular/core'

export class PersonaAvatarGroupExampleComponent {

  constructor() {
  }

}
`

const template = `<se-fe-docs-example [example]="this">${exampleHtml}</se-fe-docs-example>`

@Component({
  selector: 'se-po-persona-avatar-group-example',
  template,
  styleUrls: ['./persona-avatar-group-docs.component.scss'],
  standalone: false,
})
export class PersonaAvatarGroupExampleComponent extends SeFeDocsExampleComponent {
  @Input() public profiles: UserProfile[]
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  constructor() {
    super()
  }
}
